import { setSuperProperties } from "@asosteam/asos-web-event-tracking-bridge";
import { noticeError } from "@src/helpers/monitoring";
import { probeAdobeBeaconState } from "@src/client/adobeDebugging";

export const resolveAdobeRequestStatus = async () => {
  try {
    const adobeRequestState = await probeAdobeBeaconState();

    if (adobeRequestState === "unknown") return;

    await setSuperProperties(
      { adobe_request_state: adobeRequestState },
      { persistent: true }
    );
  } catch (error) {
    noticeError(error);
  }
};
